import {
    SCHOOL_INFO,
    QUESTIONNAIRE,
    CONTACT_DATA,
    REQUESTS,
    MOVE_IN,
    CLICKED_COMPANIES,
    SEARCH_TYPE, SCREEN_NAME, WIDGET_PROPS, WIDGET_SCHOOL_LOADING,
} from '../types';

export const setSchool = value => ({
  type: SCHOOL_INFO,
  payload: value,
});

export const setQuestionnaire = value => ({
  type: QUESTIONNAIRE,
  payload: value,
});

export const setContactData = value => ({
  type: CONTACT_DATA,
  payload: value,
});

export const setSentRequests = value => ({
  type: REQUESTS,
  payload: value,
});

export const setMoveIn = value => ({
  type: MOVE_IN,
  payload: value,
});

export const setClickedCompanies = value => ({
  type: CLICKED_COMPANIES,
  payload: value,
});

export const setSearchType = value => ({
  type: SEARCH_TYPE,
  payload: value,
});

export const setScreenName = value => ({
  type: SCREEN_NAME,
  payload: value,
});

export const setWidgetProps = value => ({
  type: WIDGET_PROPS,
  payload: value,
});

export const setWidgetSchoolLoading = value => ({
  type: WIDGET_SCHOOL_LOADING,
  payload: value,
});
